<div class="center-stage">
  <h1>Unauthorized</h1>
  <p>You are unauthorized to view this page.</p>
</div>

